export default {
  init() {
    // JavaScript to be fired on the about us page

    //javascript for the history timeline
    $('.diamond').click(function(){
      $('.diamond').removeClass('active');
      $(this).addClass('active');
      var active_milestone_class = '.' + this.id;
      $('.milestone').css('display', 'none');
      $(active_milestone_class).slideToggle(0);
      $('.milestone').removeClass('active');
      $(active_milestone_class).addClass('active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js